import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../html/element'
import { SelectCustom } from '../../../../selectCustom'
import { SCORE_MODE_ID, SCROLL_COMPONENT_IDS } from '../../../constant'
import {
  TYPE_LOGICAL_OPERATOR,
  changeTypePeriod,
  changeTypeScore,
  resetStoreScoreCredit,
  resetStoreScorePerformance,
  selectDataScoreLevelRange,
  selectLogicalOperator,
  selectTypePeriod,
  selectTypeScore,
} from '../../../store/sliceScoreLevel'
import { TYPE_PERIOD, TYPE_SCORE, TYPE_SCORE_VAlUE } from '../../constant'
import { CreditScore } from './CreditScore'
import { PerformanceScore } from './PerformanceScore'
import { AndOrButton } from './components/AndOrButton'
import classes from './scoreLevel.module.scss'

export const ScoreLevel = () => {
  const dispatch = useDispatch()

  const data = useSelector(selectDataScoreLevelRange)
  const typePeriod = useSelector(selectTypePeriod)
  const typeScoreTop = useSelector(selectTypeScore)
  const typeLogical = useSelector(selectLogicalOperator)

  //Actions
  const handleSelectType = (value) => {
    dispatch(changeTypePeriod(value))
  }
  const handleSelectTypeScore = (value) => {
    dispatch(changeTypeScore(value))
  }
  const clearDataBottomWhenHidden = () => {
    if (typeScoreTop.value === TYPE_SCORE_VAlUE.CREDIT_SCORE) {
      dispatch(resetStoreScorePerformance())
    } else {
      dispatch(resetStoreScoreCredit())
    }
  }

  const renderCredit = () => (
    <CreditScore data={data[SCORE_MODE_ID.CORPORATE_RISK]} />
  )
  const renderPerformance = () => (
    <PerformanceScore data={data[SCORE_MODE_ID.PERFORMANCE]} />
  )

  return (
    <div className={classes.ScoreLevel}>
      <div className="dFlex alignItemsCenter">
        <Element elementName="p">
          <Translate value="library.filterSetting.PERIOD_TYPE" />
          <span> :</span>
        </Element>
        <SelectCustom
          activeItem={typePeriod}
          isI18n
          data={TYPE_PERIOD}
          style={{
            borderColor: 'transparent',
            fontWeight: 600,
            color: '#3A414B',
          }}
          chooseItem={handleSelectType}
          scrollId={SCROLL_COMPONENT_IDS}
        />
      </div>
      <div style={{ paddingLeft: 26 }}>
        <SelectCustom
          activeItem={typeScoreTop}
          data={TYPE_SCORE}
          style={{
            marginTop: 12,
            width: 220,
            minHeight: 28,
            fontWeight: 600,
            color: '#3A414B',
          }}
          isI18n
          chooseItem={handleSelectTypeScore}
          scrollId={SCROLL_COMPONENT_IDS}
        />
      </div>

      {typeScoreTop.value === TYPE_SCORE_VAlUE.CREDIT_SCORE
        ? renderCredit()
        : renderPerformance()}

      <AndOrButton
        typeLogical={typeLogical}
        clearDataBottomWhenHidden={clearDataBottomWhenHidden}
      />

      {typeLogical.value !== TYPE_LOGICAL_OPERATOR.NOT.value &&
        (typeScoreTop.value === TYPE_SCORE_VAlUE.CREDIT_SCORE
          ? renderPerformance()
          : renderCredit())}
    </div>
  )
}
